import type { FlagKey } from "@/hooks/useFeatureFlags/flags";

export const GRP_PERSON_PROFILE_FLAG = "backoffice-grp-person-profile" satisfies FlagKey;
